import { Component } from 'react';

// Rede de seguranca global: em vez de tela branca, mostra uma tela de recuperacao.
// Trata tambem ChunkLoadError (asset antigo em cache apos um novo deploy) com reload automatico.
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(error) {
    const msg = (error && (error.message || String(error))) || '';
    // Falha ao carregar chunk apos deploy -> recarrega uma unica vez (asset novo)
    const isChunkError = /ChunkLoadError|Loading chunk|Loading CSS chunk|dynamically imported module/i.test(msg);
    if (isChunkError && !sessionStorage.getItem('tk_chunk_reloaded')) {
      sessionStorage.setItem('tk_chunk_reloaded', '1');
      window.location.reload();
      return { hasError: false, message: '' };
    }
    return { hasError: true, message: msg };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info?.componentStack);
    try {
      const base = process.env.REACT_APP_BACKEND_URL;
      if (base) {
        fetch(`${base}/api/client-error`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            message: (error && (error.message || String(error))) || '',
            stack: (error && error.stack) || '',
            componentStack: info?.componentStack || '',
            url: window.location.href,
            userAgent: navigator.userAgent,
          }),
          keepalive: true,
        }).catch(() => {});
      }
    } catch { /* noop */ }
  }

  handleReload = () => {
    try { sessionStorage.removeItem('tk_chunk_reloaded'); } catch { /* noop */ }
    window.location.reload();
  };

  handleHome = () => {
    window.location.href = '/';
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        data-testid="error-boundary-screen"
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px',
          textAlign: 'center',
          background: '#FDFBF7',
          fontFamily: "'DM Sans', sans-serif",
        }}
      >
        <div style={{ maxWidth: 440 }}>
          <div
            style={{
              width: 64, height: 64, borderRadius: '50%', background: '#E85D04',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 20px', color: '#fff', fontSize: 32, fontWeight: 700,
            }}
          >!</div>
          <h1 style={{ fontFamily: "'Outfit', sans-serif", fontSize: 24, fontWeight: 700, color: '#1A1A1A', margin: '0 0 8px' }}>
            Ops! Algo deu errado
          </h1>
          <p style={{ color: '#73706A', fontSize: 15, lineHeight: 1.5, margin: '0 0 8px' }}>
            A página não carregou como esperado. Se você acabou de pagar, seu pagamento foi processado
            normalmente — basta recarregar.
          </p>
          <p style={{ color: '#73706A', fontSize: 13, margin: '0 0 24px' }}>
            (This page failed to load. If you just paid, your payment went through — just reload.)
          </p>
          <button
            data-testid="error-boundary-reload-btn"
            onClick={this.handleReload}
            style={{
              width: '100%', background: '#E85D04', color: '#fff', border: 'none',
              padding: '14px', borderRadius: 10, fontSize: 16, fontWeight: 600, cursor: 'pointer',
            }}
          >
            Recarregar página
          </button>
          <button
            data-testid="error-boundary-home-btn"
            onClick={this.handleHome}
            style={{
              width: '100%', background: 'transparent', color: '#0077B6', border: 'none',
              padding: '12px', marginTop: 8, fontSize: 14, cursor: 'pointer', textDecoration: 'underline',
            }}
          >
            Voltar ao início
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
